import User from "../records/User";
import {
  ON_LOAD_USER,
  ON_LOAD_USER_SETTINGS,
  ON_UPDATE_USER_SETTINGS,
  ON_UPDATE_USER_PASSWORD
} from "../constants/user";

function isEmpty(dict = {}) {
  return Object.keys(dict).length === 0;
}

export default function user(state = new User(), action) {
  if (action.type === ON_LOAD_USER) {
    return new User(action.payload);
  }
  if (action.type == ON_LOAD_USER_SETTINGS) {
    return state.set(
      "has_recipient",
      !isEmpty(action.data.checking_account_recipient)
    );
  }
  if (action.type === ON_UPDATE_USER_SETTINGS) {
    return state.set("must_accept_offer", false);
  }
  if (action.type === ON_UPDATE_USER_PASSWORD) {
    return state.set("has_password", true);
  }
  return state;
}
